import React from "react";
import {
  TabButtonDefault,
  TabButtonUnderline,
  TabButtonPills,
  TabButtonSegments,
  TabButtonCard,
  CloseIcon,
} from "./Tabs.style";

const VariantButton = {
  default: TabButtonDefault,
  underline: TabButtonUnderline,
  pills: TabButtonPills,
  segments: TabButtonSegments,
  card: TabButtonCard,
};

/**
 * TabButton – single tab with role="tab", aria-selected, aria-controls; optional close.
 */
export default function TabButton({
  tabKey,
  label,
  selected,
  disabled,
  panelId,
  orientation,
  variant = "default",
  fullWidth,
  closable,
  onSelect,
  onClose,
  className,
  activeTabClassName,
  ...rest
}) {
  const StyledBtn = VariantButton[variant] ?? TabButtonDefault;
  const handleClick = () => {
    if (!disabled && onSelect) onSelect(tabKey);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    if (onClose) onClose(tabKey);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <StyledBtn
      type="button"
      role="tab"
      id={`tab-${tabKey}`}
      aria-selected={selected}
      aria-controls={panelId}
      aria-disabled={disabled}
      tabIndex={selected ? 0 : -1}
      $orientation={orientation}
      $disabled={disabled}
      $fullWidth={fullWidth}
      className={[className, selected && activeTabClassName].filter(Boolean).join(" ")}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      {...rest}
    >
      {label}
      {closable && (
        <CloseIcon
          role="button"
          tabIndex={-1}
          onClick={handleClose}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              onClose?.(tabKey);
            }
          }}
          aria-label={`Close ${typeof label === "string" ? label : "tab"}`}
        >
          ×
        </CloseIcon>
      )}
    </StyledBtn>
  );
}
